import {postPayload} from "./data";

export const globalSendEvent = event => async (dispatch, getState) => {
    const state = getState();
    await postPayload('segment/track', event, state);
}
